<script lang="ts" setup>
import { useIsProService } from "~/helpers/functions/IsProService";

const { t } = useI18n();
const isProService = useIsProService();

useHead({
  title: t("seo.vtcTaxi.title"),
  meta: [
    {
      name: "description",
      content: t("seo.vtcTaxi.meta.description"),
    },
    {
      property: "og:title",
      content: t("seo.vtcTaxi.meta.ogTitle"),
    },
    {
      property: "og:description",
      content: t("seo.vtcTaxi.meta.description"),
    },
    {
      property: "og:url",
      content: "https://www.tutassur.com/assurances/professionnelles/vtc-taxi/",
    },
  ],
});
</script>
<template>
  <div :class="{ 'pro-service': isProService }">
    <AssuranceProfessionnelVtcTaxiSections />
  </div>
</template>
<style scoped>
@import url("@/assets/css/proAssurance.css");
</style>
